import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as api from './admicomAPI';

const initialState = {
  allApplications: [],
  userApplications: [],
  tenant: {},
  applicationsStatus: 'idle',
};

export const getApplications = createAsyncThunk(
  'admicom/getApplications',
  async () => {
    const response = await api.getApplications();
    return response.body;
  }
);

export const getTenant = createAsyncThunk(
  'admicom/getTenant',
  async () => {
    const response = await api.getTenant();
    return response.body;
  }
);

export const admicomSlice = createSlice({
  name: 'admicom',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      // Get applications
      .addCase(getApplications.pending, (state) => {
        state.applicationsStatus = 'loading';
      })
      .addCase(getApplications.fulfilled, (state, action) => {
        state.applicationsStatus = 'succeeded';
        state.allApplications = action.payload.allApplications || [];
        state.userApplications = action.payload.userApplications || [];
      })
      .addCase(getApplications.rejected, (state) => {
        state.applicationsStatus = 'failed';
      })
      .addCase(getTenant.pending, (state) => {
        state.tenantStatus = 'loading';
      })
      .addCase(getTenant.fulfilled, (state, action) => {
        state.tenantStatus = 'succeeded';
        state.tenant = action.payload.tenant || {};
      })
      .addCase(getTenant.rejected, (state) => {
        state.tenantStatus = 'failed';
      });
  },
});

// Selectors
export const selectAllApplications = (state) => state.admicom.allApplications;
export const selectUserApplications = (state) => state.admicom.userApplications;
export const selectTenant = (state) => state.admicom.tenant;
export const selectApplicationsStatus = (state) => state.admicom.applicationsStatus;

export default admicomSlice.reducer;
